// extracted by mini-css-extract-plugin
module.exports = {"switchStyle":"ResourceRequestFilter_switchStyle__fL74b","clearBtnStyle":"ResourceRequestFilter_clearBtnStyle__2dDws"};